var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.14 2.92H10.22V1.46C10.22 0.657 9.563 0 8.76 0H5.84C5.037 0 4.38 0.657 4.38 1.46V2.92H1.46C0.657 2.92 0 3.577 0 4.38V13.14C0 13.943 0.657 14.6 1.46 14.6H13.14C13.943 14.6 14.6 13.943 14.6 13.14V4.38C14.6 3.577 13.943 2.92 13.14 2.92ZM5.84 1.46H8.76V2.92H5.84V1.46ZM10.22 9.49H8.03V11.68H6.57V9.49H4.38V8.03H6.57V5.84H8.03V8.03H10.22V9.49Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTreatment);
export default __webpack_public_path__ + "static/media/ic-treatment.19e289b10e1302394d6569cd148fe4cf.svg";
export { ForwardRef as ReactComponent };